import { Box, Button, Flex, Image, Spacer, Text } from "@chakra-ui/react";

const About = () => {
    return (
        
            <Box>
                About page
            </Box>
    );
}

export default About